import { IconButton as IconButtonComponent } from 'shared/components/ui/icon-button';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const IconButton = styled(IconButtonComponent)`
  opacity: 0;
  transition: opacity 200ms;
`;

export const Container = styled.button<{ $hasValue: boolean }>`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;

  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  margin: 0;
  min-width: 0;
  width: 100%;
  height: 3.2rem;

  cursor: pointer;
  border: none;
  border-radius: ${({ theme }) => theme.spacing(2)};
  background: transparent;
  transition: background 200ms;

  color: ${({ theme, $hasValue }) =>
    $hasValue ? theme.palette.text.primary : theme.palette.grey[600]};

  &:hover {
    background: ${({ theme }) => theme.palette.grey[300]};

    ${IconButton} {
      opacity: 1;
    }
  }
`;

export const Content = styled.span<{ $isPlaceholder: boolean }>`
  flex: 1;

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  min-width: 0;

  color: ${({ theme, $isPlaceholder }) =>
    $isPlaceholder ? theme.palette.text.secondary : theme.palette.text.primary};
`;

export const LinkContainer = styled.span`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const Link = styled.button`
  ${({ theme, as }) =>
    typographyToCss(as ? theme.typography.body2 : theme.typography.subtitle2)};

  margin: 0;
  padding: 0;

  overflow: hidden;
  background: transparent;
  cursor: pointer;
  border: none;

  text-overflow: ellipsis;
  white-space: nowrap;
  color: inherit;
  text-decoration: none;
`;

export const ChevronContainer = styled.span`
  transform: rotate(180deg);

  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const IconContainer = styled.span`
  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[600]};
`;
